import { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

import Box from "@/components/Box";
import { DownloadCrossOriginFile, ExternalTextLink } from "@/components/Links";
import { SpanText } from "@/components/Text";
import { theme } from "@/core/theme";
import { CMP_SUPPORT_PHLEBOTOMY_ANCHOR } from "@/core/urls";
import { PRICE_LIST_QUERY } from "@/graphql/support/priceList";
import useDocTitle from "@/hooks/use-doc-title";
import { PanelBoxV2 } from "@/tpo/Boxes";
import ChevronComponent from "@/tpo/Chevron";
import Group from "@/tpo/Group";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";
import { useQuery } from "@apollo/client";

import BookSupportCallModal from "../bookSupportCall/BookSupportCallModal";
import classes from "./Support.module.css";

const links = [
  {
    label: "Cardiovascular",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/25345885/calendar/any?appointmentTypeIds%5B%5D=25345885"
  },
  {
    label: "Cyrex",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/16492239/calendar/any?appointmentTypeIds%5B%5D=16492239"
  },
  {
    label: "DUTCH",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/5436212/calendar/any?appointmentTypeIds%5B%5D=5436212"
  },
  {
    label: "DUTCH - 30 mins (new users)",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=95788293"
  },
  {
    label: "OAT",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/25238453/calendar/any?appointmentTypeIds%5B%5D=25238453"
  },
  {
    label: "SIBO",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/25238424/calendar/any?appointmentTypeIds%5B%5D=25238424"
  },
  {
    label: "GI360/CSA (Doctor’s Data stool test)",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/19160324/calendar/any?appointmentTypeIds%5B%5D=19160324"
  },
  {
    label: "GI360/CSA (Doctor’s Data stool test) - 30 mins (new users)",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=95788479"
  },
  {
    label: "Thyroid",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/25238434/calendar/any?appointmentTypeIds%5B%5D=25238434"
  },
  {
    label: "Viruses, Co infections and Lyme",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/6796305/calendar/any?appointmentTypeIds%5B%5D=6796305"
  },
  {
    label: "EnviroTox",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/38486525/calendar/any?appointmentTypeIds%5B%5D=38486525"
  },
  {
    label: "MycoTox",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/38486585/calendar/any?appointmentTypeIds%5B%5D=38486585"
  },
  {
    label: "Blood Profile",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/38486620/calendar/any?appointmentTypeIds%5B%5D=38486620"
  },
  {
    label: "Microgen Dx",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/38486638/calendar/any?appointmentTypeIds%5B%5D=38486638"
  },
  {
    label: "MicroGenDx – Extended Support (New Users / 3+ Reports)",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=92647410"
  },
  {
    label: "Maven Health Metabolic Insights",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=90324704"
  },
  {
    label: "HuMap",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/38486558/calendar/any?appointmentTypeIds%5B%5D=38486558"
  },
  {
    label: "DNA + Cardiovascular Clinical Report - 30 mins",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=95781840"
  },
  {
    label: "DNA + Endocrine Clinical Report - 30 mins",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=98434690"
  },
  {
    label: "DNA + Nutrition Clinical Report - 30 mins",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=98434705"
  },
  {
    label: "DNA + Methylation & Detox Clinical Report - 30 mins",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=98434757"
  },
  {
    label: "Blood Profile",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/55302692/calendar/any?appointmentTypeIds%5B%5D=55302692"
  },
  {
    label: "TruAge",
    url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/62956334/calendar/any?appointmentTypeIds%5B%5D=62956334"
  },
  {
    label: "Salient Bio Microbiome (oral or vaginal)",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=79828507"
  },
  {
    label: "Adrenal Stress / Salivary Hormone Assessment",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=79828733"
  },
  {
    label: "Allergy and Intolerance",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=73180499"
  },
  {
    label: "GutIQ (US BioTek Stool Test)",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=94606339"
  },
  {
    label: "GutIQ (US BioTek Stool Test) - 30 mins (new users)",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=95788550"
  },
  {
    label: "NeuroBasic & Comprehensive Neurotransmitter Profile",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=94999597"
  },
  {
    label: "HuMap with Neuro add-on",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=94999628"
  },
  {
    label: "NutriStat - 40 mins",
    url: "https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=95831659"
  }
];

const findABloodDrawLinks = [
  {
    label: "Bloods and Beyond",
    url: "https://finder.bloodsandbeyond.co.uk/finder/inline/01k18kfvq0zbwan6jtcvvfq1d2"
  },
  {
    label: "Tuli Health (centrifuge not available)",
    url: "https://portal.tuli.health/#/clinic/pharmas?clinicid=96"
  }
];

const sampleReturnLinks = [
  {
    label: "UK Sample Return Instructions",
    url: "https://25282302.fs1.hubspotusercontent-eu1.net/hubfs/25282302/NEW%20UK%20DHL%20Instructions.pdf"
  },
  {
    label: "International Sample Return Instructions",
    url: "https://25282302.fs1.hubspotusercontent-eu1.net/hubfs/25282302/NEW%20INT%20DHL%20Instructions.pdf"
  },
  {
    label: "Printable International Sample Customs Document",
    url: "https://25282302.fs1.hubspotusercontent-eu1.net/hubfs/25282302/DHL%20instructions%20August%202024/International%20Sample%20Customs%20Doc.pdf"
  }
];

const REQUEST_RESEND_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSdCbuAm8IfFtZ_4tJ55Yssra0GLcSnLuV1jziRFJmO4t1k70g/viewform";

export default function Support() {
  useDocTitle("Support", false, "Regenerus");

  const { data } = useQuery(PRICE_LIST_QUERY);
  const priceDocs = data?.priceDocuments || [];

  const [showBookSupportCallModal, setShowBookSupportCallModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.hash !== `#${CMP_SUPPORT_PHLEBOTOMY_ANCHOR}`) {
      return;
    }

    const frame = requestAnimationFrame(() => {
      document.getElementById(CMP_SUPPORT_PHLEBOTOMY_ANCHOR)?.scrollIntoView({ block: "start" });
    });

    return () => cancelAnimationFrame(frame);
  }, [location.hash]);

  const testMode = new URLSearchParams(window.location.search).get("testMode");

  return (
    <>
      <PanelBoxV2
        maxWidth={1532}
        outer={{
          pt: theme.spacing.section.pt,
          pb: theme.spacing.section.pb,
          px: [20],
          bg: "haze"
        }}
        stacked
        gap={[24, 24, 40]}
      >
        {testMode ? (
          <PanelBoxV2 maxWidth={1020}>
            <PanelBoxV2
              maxWidth={760}
              outer={{
                pt: [30, 30, 60],
                pb: [50, 50, 80],
                bg: "white",
                borderRadius: 5,
                px: 20
              }}
              stacked
              gap={[24, 24, 40]}
            >
              <Stack gap={[20, 20, 28]}>
                <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
                  Book a Support call
                </Box>
                <Stack
                  as="ul"
                  fontFamily="gilroyMedium"
                  fontSize={[14, 14, 16]}
                  listStyle="disc"
                  style={{
                    listStylePosition: "inside"
                  }}
                >
                  Complete the following application form to book an appointment with one of our
                  support team
                  <Box as="li" fontFamily="inherit" fontSize="inherit" marginLeft={1}>
                    A 15-minute support call includes either test interpretation or test selection
                    for a client.
                  </Box>
                  <Box as="li" fontFamily="inherit" fontSize="inherit" marginLeft={1}>
                    During your call, we will walk you through your patient results in conjunction
                    with symptomology and provide general guidance. We are not able to give specific
                    protocols or supplement suggestions.
                  </Box>
                  <Box as="li" fontFamily="inherit" fontSize="inherit" marginLeft={1}>
                    When booking your appointment all required fields need to be completed. Failure
                    to do so may result in your call being canceled.
                  </Box>
                </Stack>
                <ButtonV2
                  withChevron
                  color="dark"
                  mx="auto"
                  onClick={() => setShowBookSupportCallModal(true)}
                  size={["sm", "sm", "md"]}
                >
                  book now
                </ButtonV2>
              </Stack>
            </PanelBoxV2>
          </PanelBoxV2>
        ) : (
          <PanelBoxV2 maxWidth={1020}>
            <PanelBoxV2
              maxWidth={760}
              outer={{
                pt: [30, 30, 60],
                pb: [50, 50, 80],
                bg: "white",
                borderRadius: 5,
                px: 20
              }}
              stacked
              gap={[24, 24, 40]}
            >
              <Box gap={0}>
                <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
                  Book a Support call
                </Box>
                <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} mt={16}>
                  Choose the support option that best suits your needs:
                </Box>
                <br />
                <br />
                <Stack
                  as="ul"
                  fontFamily="gilroyMedium"
                  fontSize={[14, 14, 16]}
                  listStyle="disc"
                  style={{
                    listStylePosition: "inside"
                  }}
                >
                  <Box as="li" fontFamily="inherit" fontSize="inherit" marginLeft={1}>
                    <SpanText fontFamily="gilroyBold">Test-Specific Support</SpanText> – guidance on
                    interpreting results from a selected test.
                  </Box>
                  <br />
                  <Box as="li" fontFamily="inherit" fontSize="inherit" marginLeft={1}>
                    <SpanText fontFamily="gilroyBold">Which Test?</SpanText> – help choosing the
                    most appropriate test for your patient.
                  </Box>
                </Stack>
                <br />
                <br />
                <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
                  Support calls are conducted via Zoom and provide general guidance only. Standard
                  support calls are 15 minutes, with extended appointments available for selected
                  tests where indicated. We do not provide specific treatment protocols or
                  supplement recommendations. Please complete all required booking fields.
                  Incomplete bookings may be cancelled.
                </Box>
              </Box>
              <Box fontFamily="gilroyBold" fontSize={[18, 18, 24]}>
                Book a call for support with the following areas
              </Box>
              <Stack gap={40}>
                <Stack className={classes.supportLinkStack}>
                  {[
                    ...links.sort((a, b) => a.label.localeCompare(b.label)),
                    {
                      label: "Other",
                      url: "https://app.acuityscheduling.com/schedule/a4df7d3b/appointment/29701754/calendar/any?appointmentTypeIds%5B%5D=29701754"
                    }
                  ].map(({ label, url }) => (
                    <Group
                      justifyContent="space-between"
                      key={label}
                      alignItems="center"
                      px={[0, 0, "8px"]}
                      py={"8px"}
                      className={classes.supportStackItem}
                    >
                      <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]}>
                        {label}
                      </Box>
                      <ButtonV2
                        as={ExternalTextLink}
                        href={url}
                        color="dark"
                        rightIcon={<ChevronComponent />}
                        size={["xs", "xs", "sm"]}
                        underline={false}
                      >
                        book now
                      </ButtonV2>
                    </Group>
                  ))}
                </Stack>
                <PanelBoxV2
                  inner={{
                    background: "linear-gradient(304deg, #FFCCCA 0%, #CCBAFF 65.73%)",
                    borderRadius: 20
                  }}
                >
                  <PanelBoxV2
                    outer={{
                      pt: [30, 30, 60],
                      pb: [50, 50, 80],
                      borderRadius: 20,
                      px: [24, 24, 40]
                    }}
                    stacked
                    gap={0}
                  >
                    <Box fontFamily="gilroyBold" fontSize={[20, 20, 28]}>
                      Not sure which test is right for your patient?
                    </Box>
                    <Box
                      fontFamily="gilroyMedium"
                      fontSize={[14, 14, 16]}
                      mt={16}
                      lineHeight={["24px", "24px", "28px"]}
                    >
                      Our Clinical Education team is here to help you find the right test for your
                      patient.
                      <br />
                      Book a Which Test call for patient-specific guidance on testing and panel
                      selection.
                    </Box>
                    <ButtonV2
                      as={ExternalTextLink}
                      underline={false}
                      color="dark"
                      withChevron
                      mt={[20, 20, 28]}
                      mx="auto"
                      href="https://app.acuityscheduling.com/schedule.php?owner=15036992&appointmentType=58258660"
                      size={["sm", "sm", "md"]}
                    >
                      Book now
                    </ButtonV2>
                  </PanelBoxV2>
                </PanelBoxV2>
              </Stack>
            </PanelBoxV2>
          </PanelBoxV2>
        )}
        <PanelBoxV2 maxWidth={1020}>
          <PanelBoxV2
            maxWidth={760}
            outer={{
              pt: [30, 30, 60],
              pb: [50, 50, 80],
              bg: "white",
              borderRadius: 5,
              px: 20
            }}
            stacked
            gap={[20, 20, 28]}
          >
            <Stack gap={[20, 20, 28]}>
              <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
                Request a resend
              </Box>
              <Box
                fontFamily="gilroyMedium"
                fontSize={[14, 14, 16]}
                lineHeight={["24px", "24px", "28px"]}
              >
                If you require a full replacement kit, individual components (such as lancets or
                vials), or a replacement shipping bag or delivery waybill, please complete the form
                below. Our Customer Service team will arrange this for you
              </Box>
            </Stack>
            <ButtonV2
              as={ExternalTextLink}
              underline={false}
              color="dark"
              withChevron
              href={REQUEST_RESEND_FORM_URL}
              alignSelf="flex-start"
              size={["sm", "sm", "md"]}
              target="_blank"
              rel="noopener noreferrer"
            >
              fill form
            </ButtonV2>
          </PanelBoxV2>
        </PanelBoxV2>
        <PanelBoxV2
          maxWidth={1020}
          outer={{
            id: CMP_SUPPORT_PHLEBOTOMY_ANCHOR,
            style: { scrollMarginTop: 120 }
          }}
        >
          <PanelBoxV2
            maxWidth={760}
            outer={{
              pt: [30, 30, 60],
              pb: [50, 50, 80],
              bg: "white",
              borderRadius: 5,
              px: 20
            }}
            stacked
            gap={[24, 24, 40]}
          >
            <Stack gap={[20, 20, 28]}>
              <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} lineHeight="46px">
                Find a Blood Draw*
              </Box>
              <Box>
                <Box fontFamily="gilroyBold" fontSize={[14, 14, 16]} lineHeight="24px">
                  Before booking an appointment, it is important to check your test kit instructions
                  to confirm if sample collection requires centrifugation.
                </Box>
                <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} lineHeight="24px">
                  If it does, verify that the clinic or provider can accommodate this need when
                  scheduling your appointment.
                </Box>
                <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} lineHeight="24px">
                  Likewise, please check with the clinic or provider if you require a blood draw for
                  a minor (under 18 years of age) prior to booking.
                </Box>
              </Box>
            </Stack>
            <Stack className={classes.supportLinkStack}>
              {findABloodDrawLinks.map(({ label, url }) => (
                <Group
                  justifyContent="space-between"
                  key={label}
                  alignItems="center"
                  px={[0, 0, "8px"]}
                  py={"8px"}
                  className={classes.supportStackItem}
                >
                  <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]}>
                    {label}
                  </Box>
                  <ButtonV2
                    as={ExternalTextLink}
                    href={url}
                    color="dark"
                    rightIcon={<ChevronComponent />}
                    size={["xs", "xs", "sm"]}
                    underline={false}
                  >
                    book now
                  </ButtonV2>
                </Group>
              ))}
            </Stack>
            <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]} lineHeight="24px">
              All blood draw providers listed operate independently of Regenerus Labs, and their
              fees are not included in the cost of any test.
              <br />
              Regenerus Labs Ltd is not liable for any losses or damages arising from the use of
              information on our website, or from failure to follow the directions provided.
            </Box>
          </PanelBoxV2>
        </PanelBoxV2>
        <PanelBoxV2 maxWidth={1020}>
          <PanelBoxV2
            maxWidth={760}
            outer={{
              pt: [30, 30, 60],
              pb: [50, 50, 80],
              bg: "white",
              borderRadius: 5,
              px: 20
            }}
            stacked
            gap={[24, 24, 40]}
          >
            <Stack gap={[20, 20, 28]}>
              <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} lineHeight="46px">
                Latest Price list
              </Box>
            </Stack>
            <Stack className={classes.supportLinkStack}>
              {priceDocs.map(pd => (
                <Group
                  justifyContent="space-between"
                  alignItems="center"
                  px={[0, 0, "8px"]}
                  py={"8px"}
                  className={classes.supportStackItem}
                  key={pd.id}
                >
                  <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]}>
                    {pd.displayName}
                  </Box>
                  <DownloadCrossOriginFile
                    fileUrl={pd.url}
                    fileName={pd.filename}
                    contentType={pd.contentType}
                    redirect
                    trigger={
                      <ButtonV2 withChevron color="dark" size={["xs", "xs", "sm"]}>
                        download
                      </ButtonV2>
                    }
                  />
                </Group>
              ))}
            </Stack>
          </PanelBoxV2>
        </PanelBoxV2>
        <PanelBoxV2 maxWidth={1020}>
          <PanelBoxV2
            maxWidth={760}
            outer={{
              pt: [30, 30, 60],
              pb: [50, 50, 80],
              bg: "white",
              borderRadius: 5,
              px: 20
            }}
            stacked
            gap={[24, 24, 40]}
          >
            <Stack gap={[20, 20, 28]}>
              <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]} lineHeight="46px">
                Sample return details
              </Box>
            </Stack>
            <Stack className={classes.supportLinkStack}>
              {sampleReturnLinks.map(({ label, url }) => (
                <Group
                  justifyContent="space-between"
                  key={label}
                  alignItems="center"
                  px={[0, 0, "8px"]}
                  py={"8px"}
                  className={classes.supportStackItem}
                >
                  <Box fontFamily="gilroyBold" fontSize={[16, 16, 18]}>
                    {label}
                  </Box>
                  <ButtonV2
                    as={ExternalTextLink}
                    href={url}
                    color="dark"
                    rightIcon={<ChevronComponent />}
                    size={["xs", "xs", "sm"]}
                    underline={false}
                  >
                    visit
                  </ButtonV2>
                </Group>
              ))}
            </Stack>
          </PanelBoxV2>
        </PanelBoxV2>
        <PanelBoxV2 maxWidth={1020}>
          <PanelBoxV2
            maxWidth={760}
            outer={{
              pt: [30, 30, 60],
              pb: [50, 50, 80],
              bg: "white",
              borderRadius: 5,
              px: 20
            }}
            stacked
            gap={[20, 20, 28]}
          >
            <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
              General support
            </Box>
            <Box fontSize={[14, 14, 16]}>
              <Box as="span" fontSize="inherit">
                Clinical Support Team
              </Box>{" "}
              at{" "}
              <ExternalTextLink
                fontSize="inherit"
                href="mailto:support@regeneruslabs.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                support@regeneruslabs.com
              </ExternalTextLink>
            </Box>
            <Box fontSize={[14, 14, 16]}>
              <Box fontSize="inherit">
                <Box as="span" fontSize="inherit">
                  Client Service Team
                </Box>{" "}
                at{" "}
                <ExternalTextLink
                  fontSize="inherit"
                  href="mailto:support@regeneruslabs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  support@regeneruslabs.com
                </ExternalTextLink>
              </Box>
              <Box fontSize="inherit">or by phone, Monday-Friday, from 9:30am - 4:30pm.</Box>
              <Box fontSize="inherit">Phone lines are closed between 1:15 pm and 2:15 pm.</Box>
              <Box fontSize="inherit" textDecoration="underline">
                Tel: 020 3750 0870.
              </Box>
            </Box>
          </PanelBoxV2>
        </PanelBoxV2>
      </PanelBoxV2>
      <BookSupportCallModal
        show={showBookSupportCallModal}
        onClose={() => setShowBookSupportCallModal(false)}
      />
    </>
  );
}
